import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CategoryPage from "../pages/category/page";
import TopicPage from "../pages/topic/page";
import UserPage from "../pages/user/page";
import PostPage from "../pages/post/page";
import AboutPage from "../pages/about/page";
import SearchPage from "../pages/search/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category/:categoryId",
    element: <CategoryPage />,
  },
  {
    path: "/topic/:topicId",
    element: <TopicPage />,
  },
  {
    path: "/user/:userId",
    element: <UserPage />,
  },
  {
    path: "/post",
    element: <PostPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/search",
    element: <SearchPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;